import { GET_EDUCATION_REGISTER_SUCCESS, GET_EDUCATION_REGISTER_FAILURE } from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case GET_EDUCATION_REGISTER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case GET_EDUCATION_REGISTER_FAILURE:
      return { ...state, isLoading: false, errorData: action.payload, error: true };
    default:
      return { ...state };
  }
};
